import { UnicoCheckBuilder, UnicoThemeBuilder } from 'unico-webframe'
import theme from '@frete.com/fuel-foundation/fretepago/theme.json'

const unicoTheme = new UnicoThemeBuilder()
  .setColorSilhouetteSuccess(theme.success.icon.default)
  .setColorSilhouetteError(theme.danger.icon.default)
  .setColorSilhouetteNeutral(theme.neutral.icon.inverted)
  .setBackgroundColor(theme.neutral.background.default)
  .setColorText(theme.neutral.text.strong)
  .setBackgroundColorComponents(theme.neutral.background.default)
  .setColorTextComponents(theme.neutral.text.strong)
  .setBackgroundColorButtons(theme.brand.background.default)
  .setColorTextButtons(theme.neutral.icon.inverted)
  .setBackgroundColorBoxMessage(theme.neutral.background.default)
  .setColorTextBoxMessage(theme.neutral.text.strong)
  .setHtmlPopupLoading(
    `
    <style>
      .loading {
        display: inline-block;
        width: 26px;
        height: 26px;
        border: 2px solid white;
        border-radius: 50%;
        border-top-color: #E04747;
        animation: spin 1s ease-in-out infinite;
        -webkit-animation: spin 1s ease-in-out infinite;
        margin-top: 16px;
      }
      
      .container {
        display: flex; 
        flex-direction: 
        column; align-items:center;
      }

      .title {
        font-size: 32px;
        font-weight: 700;
      }

      .paragraph {
        color: #636B7E; 
        font-size: 16px; 
        margin-top: 8px;
      }
      
      @keyframes spin { to { transform: rotate(360deg); } }
  </style>
  <div class="container">
    <h2 class="title">Aguarde</h2>
    <p class="paragraph">Isso pode levar alguns segundos!</p>
    <div class="loading"></div>
  </div>`,
  )
  .build()

const urlPathModels = `${window.location.protocol}//${window.location.host}/models`

export * from 'unico-webframe'
export default new UnicoCheckBuilder()
  .setTheme(unicoTheme)
  .setModelsPath(urlPathModels)
  .setResourceDirectory('/resources')
  .build()
